import styled from 'styled-components';

export const InfoOfertasContainer = styled.div`
  max-width: 720px;
  display: flex;
  margin-left: auto;
  gap: 5px;
  overflow: auto;
  direction: rtl;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
`;
